var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 4.02246H11.667V4.20024H11.4893V4.02246Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 4.2002H12.0225V4.37797H11.8447V4.2002Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 4.55566H11.8447V4.73344H12.0225V4.55566Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 4.37793H11.667V4.55571H11.4893V4.37793Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 4.7334H11.4893V4.91118H11.667V4.7334Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 4.91113H12.0225V5.08891H11.8447V4.91113Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 5.2666H11.8447V5.44438H12.0225V5.2666Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 5.08887H11.667V5.26664H11.4893V5.08887Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 5.44434H11.4893V5.62211H11.667V5.44434Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 5.62207H12.0225V5.79985H11.8447V5.62207Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 5.97754H11.8447V6.15532H12.0225V5.97754Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 5.7998H11.667V5.97758H11.4893V5.7998Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 6.15527H11.4893V6.33305H11.667V6.15527Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 6.33301H12.0225V6.51079H11.8447V6.33301Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 6.68945H11.8447V6.86723H12.0225V6.68945Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 6.51172H11.667V6.6895H11.4893V6.51172Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 6.86719H11.4893V7.04497H11.667V6.86719Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 7.04492H12.0225V7.2227H11.8447V7.04492Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 7.40039H11.8447V7.57817H12.0225V7.40039Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 7.22266H11.667V7.40043H11.4893V7.22266Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 7.57812H11.4893V7.7559H11.667V7.57812Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 8.4668H12.0225V8.64457H11.8447V8.4668Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 8.82227H11.8447V9.00004H12.0225V8.82227Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 8.64453H11.667V8.82231H11.4893V8.64453Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 9H11.4893V9.17778H11.667V9Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 9.17773H12.0225V9.35551H11.8447V9.17773Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 9.5332H11.8447V9.71098H12.0225V9.5332Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 9.35547H11.667V9.53325H11.4893V9.35547Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 9.71094H11.4893V9.88872H11.667V9.71094Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 9.88867H12.0225V10.0664H11.8447V9.88867Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 10.2441H11.8447V10.4219H12.0225V10.2441Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 10.0664H11.667V10.2442H11.4893V10.0664Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 10.4219H11.4893V10.5997H11.667V10.4219Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 10.5996H12.0225V10.7774H11.8447V10.5996Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 10.9551H11.8447V11.1329H12.0225V10.9551Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 10.7773H11.667V10.9551H11.4893V10.7773Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 11.1328H11.4893V11.3106H11.667V11.1328Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 11.3105H12.0225V11.4883H11.8447V11.3105Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 11.667H11.8447V11.8448H12.0225V11.667Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 11.4883H11.667V11.6661H11.4893V11.4883Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 11.8447H11.4893V12.0225H11.667V11.8447Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 12.0225H12.0225V12.2002H11.8447V12.0225Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 12.3779H11.8447V12.5557H12.0225V12.3779Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 12.2002H11.667V12.378H11.4893V12.2002Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 12.5557H11.4893V12.7334H11.667V12.5557Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 12.7334H12.0225V12.9112H11.8447V12.7334Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 13.0889H11.8447V13.2666H12.0225V13.0889Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 12.9111H11.667V13.0889H11.4893V12.9111Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 13.2666H11.4893V13.4444H11.667V13.2666Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 13.4443H12.0225V13.6221H11.8447V13.4443Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 13.7998H11.8447V13.9776H12.0225V13.7998Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 13.6221H11.667V13.7998H11.4893V13.6221Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 13.9775H11.4893V14.1553H11.667V13.9775Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 14.1553H12.0225V14.3331H11.8447V14.1553Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0225 14.5117H11.8447V14.6895H12.0225V14.5117Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 14.333H11.667V14.5108H11.4893V14.333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 14.6895H11.4893V14.8672H11.667V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 15.0449H11.8448V15.2227H11.667V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8447 15.045V14.8672H12.0225V15.045H11.8447Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1338 14.6895H11.3116V14.8672H11.1338V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1329 15.0449H10.9551V15.2227H11.1329V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 14.6895H10.9551V14.8672H10.7773V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7774 15.0449H10.5996V15.2227H10.7774V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4219 14.6895H10.5997V14.8672H10.4219V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4219 15.0449H10.2441V15.2227H10.4219V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0664 14.6895H10.2442V14.8672H10.0664V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0664 15.0449H9.88867V15.2227H10.0664V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71094 14.6885H9.88872V14.8663H9.71094V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71098 15.0449H9.5332V15.2227H9.71098V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35547 14.6885H9.53325V14.8663H9.35547V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35551 15.0449H9.17773V15.2227H9.35551V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.6885H9.17778V14.8663H9V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 15.0449H8.82227V15.2227H9.00004V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64453 14.6885H8.82231V14.8663H8.64453V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64457 15.0449H8.4668V15.2227H8.64457V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28906 14.6885H8.46684V14.8663H8.28906V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28911 15.0449H8.11133V15.2227H8.28911V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93359 14.6895H8.11137V14.8672H7.93359V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93364 15.0449H7.75586V15.2227H7.93364V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57812 14.6895H7.7559V14.8672H7.57812V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57817 15.0449H7.40039V15.2227H7.57817V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22266 14.6895H7.40043V14.8672H7.22266V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2227 15.0449H7.04492V15.2227H7.2227V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86621 14.6895H7.04399V14.8672H6.86621V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86625 15.0449H6.68848V15.2227H6.86625V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51074 14.6895H6.68852V14.8672H6.51074V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51079 15.0449H6.33301V15.2227H6.51079V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15527 14.6895H6.33305V14.8672H6.15527V14.6895Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15532 15.0449H5.97754V15.2227H6.15532V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 14.6885H5.97758V14.8663H5.7998V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79985 15.0449H5.62207V15.2227H5.79985V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44434 14.6885H5.62211V14.8663H5.44434V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44438 15.0449H5.2666V15.2227H5.44438V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08887 14.6885H5.26664V14.8663H5.08887V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08891 15.0449H4.91113V15.2227H5.08891V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7334 14.6885H4.91118V14.8663H4.7334V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73344 15.0449H4.55566V15.2227H4.73344V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37793 14.6885H4.55571V14.8663H4.37793V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37797 15.0449H4.2002V15.2227H4.37797V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02246 14.6885H4.20024V14.8663H4.02246V14.6885Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4893 15.0449H11.3115V15.2227H11.4893V15.0449Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3111 1V3.48889H13.8C13.8 4.36743 13.8042 5.24608 13.8 6.12462V17H3.48889V14.5111H1V1H11.3111ZM13.4444 6.1237V3.84444H11.3111V7.93333H11.6667C11.7266 7.93333 11.7859 7.93019 11.8444 7.92404V7.75556H12.0222V7.8958C12.8204 7.72539 13.4397 6.99495 13.4444 6.1237ZM11.3111 8.28889V14.5111H3.84444V16.6444H13.4444V7.30821C13.1235 7.80037 12.6121 8.15499 12.0222 8.2581V8.28889H11.8444V8.28126C11.7858 8.28631 11.7265 8.28889 11.6667 8.28889L11.6667 8.46667H11.4889V8.28889H11.3111ZM10.9556 8.28889V14.1556H1.35556V1.35556H10.9556V7.93333H5.34034L6.99241 6.28126L6.74098 6.02985L4.65972 8.11111L6.74098 10.1924L6.99241 9.94096L5.34034 8.28889H10.9556Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUpload);
export default __webpack_public_path__ + "static/media/bulk-upload.db8e1fd6f6113db2d96f281e0a664781.svg";
export { ForwardRef as ReactComponent };